import React, { useState, useEffect } from "react";
import { cn } from "../../lib/utils";

const ProductGallery = ({ images, alt }) => {
  const [active, setActive] = useState(0);
  useEffect(() => setActive(0), [images]);

  return (
    <div className="flex flex-col-reverse gap-3 lg:flex-row" data-testid="product-gallery">
      {/* Thumbnails */}
      <div className="flex gap-3 overflow-x-auto no-scrollbar lg:flex-col lg:overflow-visible">
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            aria-label={`View image ${i + 1}`}
            data-testid={`gallery-thumb-${i}`}
            className={cn(
              "aspect-[4/5] w-16 shrink-0 overflow-hidden bg-cream lg:w-20",
              active === i ? "ring-2 ring-ink" : "opacity-60 hover:opacity-100"
            )}
          >
            <img src={img} alt={`${alt} ${i + 1}`} loading="lazy" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>

      {/* Main image */}
      <div className="relative flex-1 overflow-hidden bg-cream">
        <div className="aspect-[4/5] w-full">
          <img
            src={images[active]}
            alt={alt}
            className="h-full w-full object-cover animate-fade-in"
            data-testid="gallery-main-image"
          />
        </div>
      </div>
    </div>
  );
};

export default ProductGallery;
